<style lang="stylus">
        .files-selector
            margin 14px 0 0 0
            margin-right 40px
            .selector-box
                height 46px
                padding 0 11px
                file_selectorBg()
                display flex
                justify-content space-between
                align-items center
                font-size 12px
                border-radius 6px
                .shortline
                    width 1px
                    height 18px
                    background #017fff
                    margin 0 20px 0 11px
                .cancel-shortline
                    margin 0 11px 0 20px
                .selector-info
                    display flex
                    height 24px
                    align-items center
                    .info-selectall
                        color #017fff
                        padding 3px 9px
                        border-radius 3px
                        transition background .2s linear
                        &:hover
                            background #CBE6FF
                    .info-select
                        color #222
                        span
                            margin-left 20px
                            padding 0 13px
                            color #fff
                            background #017EFF
                            border-radius 10px
                .selector-tool
                    display flex
                    align-items center
                    .tool-icon
                        display flex
                        align-items center
                        height 24px
                        margin-right 24px
                        padding-right 3px
                        border-radius 2px
                        transition background .2s linear
                        color #017fff
                        &:hover
                            background #CBE6FF
                        svg
                            width 24px
                            height 24px
                            margin-right 3px
                        &.not-margin
                            margin-right 0
                    .tool-cancel
                        height 24px
                        padding 3px 9px
                        border-radius 3px
                        color #017fff
                        transition background .2s linear
                        &:hover
                            background #CBE6FF
        .clickpointer
            cursor pointer
            user-select none


        .tree-box
            height 200px
            overflow-y scroll
            margin-bottom 15px
            .publishModal-tree
                padding-left 10px
                margin-top 5px
                position relative
                width 100%
                .publishModal-tree-node
                    display flex
                    flex-wrap wrap
                    padding 3px 5px
                    >p
                        width calc(100% - 24px)
                        font-size 12px
                        height 24px
                        line-height 24px
                        text-indent 8px
                        user-select none
                        cursor pointer
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                .publishModal-tree-folder
                    position relative
                    img
                        width 24px
                    .publishModal-tree-arrow
                        position absolute
                        left -8px
                        top 9px
                        width 12px
                        height 12px
                        transform rotate(-90deg)
                    .publishModal-tree-arrow-openFolder
                        transform rotate(0deg)
                .publishModal-tree-file
                    position relative
                    img
                        width 21px
                    .item-icon
                        position absolute
                        left 17px
                        top -3px
                        display flex
                        justify-content space-around
                        align-items center
                        width 12px
                        height 12px
                        border-radius 50%
                        border 1px solid #017fff
                        fill #017fff
                        background #fff
                    .pending
                        border-color #f90
                        fill #f90
                .highlight
                    background #e5e5e5
    .custom-restore-icon
        width 20px !important
        height 20px !important
        fill #017eff
        stroke #017eff
    .dark-theme__fileSelector
        .selector-box
            background #324354
            .selector-info
                .info-select
                    color #fff
</style>

<template>
    <div class="files-selector" :class="{ 'dark-theme__fileSelector': isPCDarkMode == 2 }" :style="{ margin: s_margin }">
        <div class="selector-box">
            <div class="selector-info">
                <p class="info-selectall clickpointer" @click="selectAllFiles">{{ allFlag ? $t("selectAll2") : $t("selectAll") }}</p>
                <span class="shortline"></span>
                <p class="info-select">
                    {{ $t("selected") }}
                    <span>{{ fileNum }}</span>
                </p>
            </div>
            <div class="selector-tool">
                <div class="tool-icon clickpointer" v-if="type == 'cloudFile' && isPC" @click="showOpenFiles">
                    <iconSymbol name="fileselect-open" />
                    <p>{{ $t("openFile") }}</p>
                </div>
                <div class="tool-icon clickpointer" v-if="type == 'cloudFile'" @click="showModalBtn">
                    <iconSymbol name="fileselect-move" />
                    <p>{{ $t("moveFile") }}</p>
                </div>
                <div class="tool-icon clickpointer" v-if="type == 'cloudFile'" @click="downloadFiles">
                    <iconSymbol name="fileselect-download" />
                    <p v-if="isSelectSingleColudFile">{{ $t("download") }}</p>
                    <p v-else>{{ $t("batch") }}</p>
                </div>
                <div class="tool-icon clickpointer" v-if="type == 'recycle'" @click="restoreBtn">
                    <iconSymbol class="custom-restore-icon" name="restoreIcon" />
                    <p>{{ $t("recover") }}</p>
                </div>
                <div class="tool-icon clickpointer not-margin" v-if="['cloudFile', 'recycle', 'openRecord'].includes(type)" @click="deleleBtn">
                    <iconSymbol name="fileselect-delete" />
                    <p>{{ $t("deleteFile") }}</p>
                </div>
                <span v-if="['cloudFile', 'recycle', 'openRecord'].includes(type)" class="shortline cancel-shortline"></span>
                <p class="tool-cancel clickpointer" @click="cancelSelect">{{ $t("cancel") }}</p>
            </div>
        </div>
        <!-- 文件选择器 -->
        <FolderModal v-if="showModal" :title="$t('moveFile')" :showActionBtn="true" @actionConfirm="moveEvent" @closeModal="closeModal()" />
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import FolderModal from "./FolderModal.vue";
    // @Component 修饰符注明了此类为一个 Vue 组件

    @Component({
        components: {
            FolderModal,
        },
    })
    export default class FilesSelector extends Vue {
        @Prop()
        type;
        @Prop()
        totalNum;
        @Prop()
        fileNum;
        @Prop()
        s_margin;
        @Prop()
        nowPrefix;

        // allFlag = false;  // 是否点击过全选
        searchValue = "";
        showModal = false;
        get userInfo() {
            return this.$store.state.userInfo;
        }
        get vipState() {
            if (this.isPC) {
                return this.$store.state.pcVip;
            } else {
                return this.$store.state.publicStore.vip;
            }
        }
        get selectMovePrefix() {
            return this.$store.state.selectMovePrefix;
        }
        get isSel() {
            let pathList = this.selectMovePrefix.split("/");
            if (!this.isPrivate) {
                pathList.shift();
                pathList.shift();
            }
            return pathList.join("/") === this.nowPrefix;
        }
        get allFlag() {
            return this.totalNum == this.fileNum;
        }

        get isSelectSingleColudFile() {
            return this.$store.state.isSelectSingleColudFile;
        }

        // tool btn
        selectAllFiles() {
            // 点击全选
            // this.allFlag = !this.allFlag;
            this.$emit("selectAllFiles", this.allFlag ? 0 : 1);
            this.sensors.track("fileOperations", {
                Catalogues: "Workbench",
                operation_type: "allSelect",
            });
        }
        showModalBtn() {
            this.showModal = true;
            this.sensors.track("fileOperations", {
                Catalogues: "Workbench",
                operation_type: "copy",
            });
        }
        // 批量下载文件
        downloadFiles() {
            if (!this.$checkAuth({ type: "downloadFiles", buyTrigger: "others", pcParams: { newUpgrade: 0, upgrade: 0 } })) return;
            this.$emit("downloadFiles");
            this.sensors.track("fileOperations", {
                Catalogues: "Workbench",
                operation_type: "batchDownload",
            });
        }
        showOpenFiles() {
            if (this.fileNum > 20) {
                this.$store.commit("setState", {
                    type: "showOpenFilesDialog",
                    data: true,
                });
            } else {
                this.$bus.$emit("openFilesConfirm", 1);
            }
        }
        restoreBtn() {
            this.$emit("recycleFiles");
            this.sensors.track("multipleSelectionRestore", {
                Catalogues: "Workbench",
                // operation_type: 'multipleSelectionRestore'
            });
        }
        deleleBtn() {
            this.$emit("delFiles");
            this.sensors.track("fileOperations", {
                Catalogues: "Workbench",
                operation_type: "delete",
            });
        }
        cancelSelect() {
            // 退出选择状态
            this.closeModal();
            this.$emit("cancelSelect");
            this.sensors.track("fileOperations", {
                Catalogues: "Workbench",
                operation_type: "cancel",
            });
        }

        // modal
        closeModal() {
            this.showModal = false;
        }
        moveEvent(type) {
            this.$emit("modalEvent", {
                eventType: type,
                targetType: "files",
            });
        }
        //生命周期
        mounted() {
            this.sensors.track("multipleSelectionFiles", {
                Catalogues: "Workbench",
            });
        }

        destroyed() {}

        created() {}
    }
</script>

<i18n>
{
  "zh": {
    "selectAll": "全选",
    "selectAll2": "取消全选",
    "selected": "已选",
    "notSelect": "请选择文件夹",
    "copy": "复制",
    "move": "移动",
    "cancel": "取消",
    "openFile": "打开",
    "moveFile": "移动/复制",
    "batch": "批量下载",
    "download": "下载",
    "personal": "个人云",
    "deleteFile": "删除",
    "recover": "恢复"
  },
  "en": {
    "selectAll": "Select all",
    "selectAll2": "Cancel",
    "selected": "Selected",
    "notSelect": "Please select a folder",
    "copy": "Copy",
    "move": "Move",
    "cancel": "Cancel",
    "openFile": "Open",
    "moveFile": "Move/Copy",
    "batch": "Batch Download",
    "download": "Download",
    "personal": "Personal",
    "deleteFile": "Delete",
    "recover": "Restore"
  },
  "fr": {
    "selectAll": "tout sélectionner",
    "selectAll2": "tout déselectionner",
    "selected": "choisi",
    "notSelect": "Veuillez sélectionner un dossier",
    "copy": "Copie",
    "move": "Mobile",
    "cancel": "Annuler",
    "openFile": "Ouvrir",
    "moveFile": "déplacer / copier",
    "batch": "Téléchargement en masse",
    "download": "Télécharger",
    "personal": "Cloud personnel",
    "deleteFile": "supprimer",
    "recover": "Récupération"
  },
  "de": {
    "selectAll": "Alle wählen",
    "selectAll2": "Alles wiederufen",
    "selected": "Ausgewählt",
    "notSelect": "Bitte wählen Sie einen Ordner",
    "copy": "Kopieren",
    "move": "Mobiltelefon",
    "cancel": "Abbrechen",
    "openFile": "Öffnen",
    "moveFile": "Verschieben/Kopieren",
    "batch": "Batch-Download",
    "download": "Herunterladen",
    "personal": "Persönlicher Cloud",
    "deleteFile": "Löschen",
    "recover": "Wiederherstellen"
  },
  "jp": {
    "selectAll": "すべて選択",
    "selectAll2": "すべて選択解除",
    "selected": "選択済み",
    "notSelect": "フォルダを選択してください",
    "copy": "コピー",
    "move": "モバイル",
    "cancel": "キャンセル",
    "openFile": "開く",
    "moveFile": "移動/コピー",
    "batch": "一括ダウンロード",
    "download": "ダウンロード",
    "personal": "個人クラウド",
    "deleteFile": "削除",
    "recover": "元に戻す"
  },
  "es": {
    "selectAll": "seleccionar todo",
    "selectAll2": "Deselecciona todo",
    "selected": "seleccionado",
    "notSelect": "Por favor seleccione una carpeta",
    "copy": "Copiar",
    "move": "móvil",
    "cancel": "cancelar",
    "openFile": "Abrir",
    "moveFile": "Mover / Copiar",
    "batch": "Descarga por lotes",
    "download": "Descargar",
    "personal": "Nube Personal",
    "deleteFile": "Eliminar",
    "recover": "Restaurar"
  },
  "pt": {
    "selectAll": "selecionar tudo",
    "selectAll2": "Desmarque todos",
    "selected": "selecionado",
    "notSelect": "Selecione uma pasta",
    "copy": "cópia de",
    "move": "Móvel",
    "cancel": "cancelar",
    "openFile": "Abrir",
    "moveFile": "mover/copiar",
    "batch": "Descarregamento em Lote",
    "download": "Descarregar",
    "personal": "Pessoal",
    "deleteFile": "excluir",
    "recover": "Restaurar"
  },
  "it": {
    "selectAll": "seleziona tutto",
    "selectAll2": "Deseleziona tutto",
    "selected": "selezionato",
    "notSelect": "Seleziona una cartella",
    "copy": "copia",
    "move": "mobile",
    "cancel": "Annulla",
    "openFile": "apri",
    "moveFile": "sposta / copia",
    "batch": "Scarica in Blocco",
    "download": "Scarica",
    "personal": "Personali",
    "deleteFile": "elimina",
    "recover": "Ripristina"
  },
  "tw": {
    "selectAll": "全選",
    "selectAll2": "取消全選",
    "selected": "已選",
    "notSelect": "請選擇檔案夾",
    "copy": "複製",
    "move": "移動",
    "cancel": "取消",
    "openFile": "打開",
    "moveFile": "移動/複製",
    "batch": "批量下載",
    "download": "下載",
    "personal": "個人雲端硬碟",
    "deleteFile": "刪除",
    "recover": "恢復"
  },
  "kr": {
    "selectAll": "전부 선택",
    "selectAll2": "전부 선택 취소",
    "selected": "선택된",
    "notSelect": "폴더를 선택하세요",
    "copy": "복사",
    "move": "이동",
    "cancel": "취소",
    "openFile": "열기",
    "moveFile": "이동 / 복사",
    "batch": "일괄 다운로드",
    "download": "다운로드",
    "personal": "개인 클라우드",
    "deleteFile": "삭제",
    "recover": "복구"
  },
  "id": {
    "selectAll": "Pilih semua",
    "selectAll2": "Batalkan",
    "selected": "Dipilih",
    "notSelect": "Pilih folder",
    "copy": "Salin",
    "move": "Pindahkan",
    "cancel": "Batalkan",
    "openFile": "Buka",
    "moveFile": "Pindah/Salin",
    "batch": "Unduh Massal",
    "download": "Unduh",
    "personal": "Personal",
    "deleteFile": "Hapus",
    "recover": "Pulihkan"
  }
}
</i18n>
